import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { getEnvironmentData } from '@krea/common/utils'

const { primaryLanguage } = getEnvironmentData()

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: {
				customerWeb: require('./translations/customer-web/en.json'),
				common: require('@krea/common/translations/common/en.json')
			},
			sv: {
				customerWeb: require('./translations/customer-web/sv.json'),
				common: require('@krea/common/translations/common/sv.json')
			},
			fi: {
				customerWeb: require('./translations/customer-web/fi.json'),
				common: require('@krea/common/translations/common/fi.json')
			}
		},
		lng: primaryLanguage,
		fallbackLng: 'en',
		supportedLngs: ['sv', 'en', 'fi'],
		ns: ['customerWeb', 'common'],
		defaultNS: 'customerWeb',
		fallbackNS: 'common',
		interpolation: {
			escapeValue: false
		},
		react: {
			transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'ul', 'li']
		}
	})

export default i18n
